import { Box, Typography } from "@mui/material";
import { Pagination, SuperChatLog } from "@/organism";
import { ChatSession } from "@/organism/SuperChatLog/List";
import useList from "./useList";

/**
 * 채팅 로그 리스트 템플릿 Props
 */
export type ListProps = {
  page: number;
  count: number;
  list: ChatSession[];
  isLoading?: boolean;
};

/**
 * 채팅 로그 리스트 템플릿
 *
 * @description 채팅 로그 목록을 표시하는 템플릿 컴포넌트
 * @param props ListProps
 * @returns JSX.Element
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export const List = (props: ListProps) => {
  const { page, count, list, isLoading } = props;
  const {
    rowsPerPage,
    filterValues,
    handlePageChange,
    handleRowsPerPageChange,
    handleFilterChange,
    handleResetFilters,
    handleRefresh,
    handleExport,
    handleViewSession,
  } = useList();

  console.log("rowsPerPage", page, count, list, isLoading);

  return (
    <Box>
      {/* 헤더 */}
      <Box sx={{ mb: 3 }}>
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          채팅 로그 관리
        </Typography>
        <Typography variant="body2" color="text.secondary">
          고객과의 채팅 세션을 조회하고 관리할 수 있습니다.
        </Typography>
      </Box>

      <Box display={"flex"} flexDirection={"column"} gap={2}>
        <SuperChatLog.Filter
          values={filterValues}
          loading={isLoading}
          onChange={handleFilterChange}
          onReset={handleResetFilters}
          onRefresh={handleRefresh}
          onExport={handleExport}
        />
        <SuperChatLog.List
          sessions={list}
          loading={isLoading}
          onViewSession={handleViewSession}
        />
        {count > 0 && (
          <Pagination
            count={count}
            page={page - 1}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPage={rowsPerPage}
          />
        )}
      </Box>
    </Box>
  );
};
